import React from 'react';
import PropTypes from 'prop-types';

import {
  getLogoutURI,
} from '../../utils/api';

const amFamLogo = require('../../assets/investments_logo.jpg');

export default function Header({
  openHelpModal,
}) {
  return (
    <header className="bg-white flex items-center justify-space-between" style={{ borderBottom: '1px solid black' }}>
      <img src={amFamLogo} alt="amfamlogo" className="height-fill margin-left-30" />
      <div className="flex">
        <button type="button" onClick={openHelpModal} className="a bg-transparent border-0 color-blue margin-right-30">Get Help</button>
        <button type="button" onClick={getLogoutURI} className="a bg-transparent border-0 color-blue margin-right-30">Logout</button>
      </div>
    </header>
  );
}

Header.propTypes = {
  openHelpModal: PropTypes.func.isRequired,
};
